export const en = {
    cancel: 'Cancel',
    'set-smart-center': 'Set smart-center',
    'smart-center-title': 'Smart-center'
};
